// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"d529d5a1","498":"e693386e","943":"1fde335c"}[chunkId] + ".chunk.css";
};